import FormsLibraryPanel from '@/components/admin/FormsLibraryPanel';

export default function AdminFormsPage() {
  return <FormsLibraryPanel />;
}
